import { FC, PropsWithChildren, ReactNode, RefObject } from 'react'

import clsx from 'clsx'

import Icon from '@/components/Icon'

interface OverlayProps {
  title?: string | ReactNode
  className?: string
  backButtonRef?: RefObject<HTMLButtonElement> // TODO: find a better way
  onBack?: () => void
  hasBackButton?: boolean
  childrenClassName?: string
}

const Overlay: FC<PropsWithChildren<OverlayProps>> = ({
  children,
  title,
  className,
  backButtonRef,
  hasBackButton = true,
  childrenClassName,
  onBack
}) => {
  const onClose = () => {
    if (onBack) {
      onBack()
    }

    backButtonRef?.current?.click()
  }

  return (
    <div
      className={clsx(
        'fixed inset-0 w-full bg-white desktop:hidden',
        className
      )}
    >
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-5 py-4 pl-2.5 pr-5 text-xl font-medium">
          {hasBackButton && (
            <div onClick={onClose}>
              <Icon className="h-6 w-6 text-blue-600" name="arrow-sidebar-24" />
            </div>
          )}
          <span className="w-full">{title}</span>
        </div>
        <div
          className={clsx(
            'flex flex-col items-center gap-2 px-5',
            childrenClassName
          )}
        >
          {children}
        </div>
      </div>
    </div>
  )
}

export default Overlay
